<app-header></app-header>
<ion-content [scrollY]="false" *ngIf="paymentDashboardVM$ | async; let vm">
  <cdk-virtual-scroll-viewport
    appCustomVs
    [itemHeights]="getItemHeights(vm)"
    [indexOffset]="1"
    [bufferBefore]="vsRowBuffer"
    [bufferAfter]="vsRowBuffer"
  >
    <div #mainDivScroll class="gray-content-bg content">
      <ng-container
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
      >
        <app-page-title-banner
          [pageTitle]="'i18n.payments.paymentDashboard.appBannerTitle'|translate"
          [backgroundImageStyle]="backgroundImageStyle"
          [overlayGradient]="overlayGradient"
          [showEllipsis]="false"
        >
        </app-page-title-banner>
      </ng-container>
      <div class="dashboard-selector">
        <app-dashboard-selector
          [dashboardTabs]="vm.dashboardTabs"
        ></app-dashboard-selector>
      </div>
      <ng-container *ngIf="!vm.hasReachedCustomerLimit; else DataLimitMessage">
        <div class="dashboard-content">
          <ion-grid>
            <ion-row>
              <ion-col>
                <div
                  class="selected-territory-header"
                  [ngClass]="{ 'interaction-enabled': vm.isTMDropdownOn }"
                  (click)="redirectClick()"
                >
                  {{ (vm.isTMDropdownOn ? tmSelectionText :
                  'i18n.payments.paymentDashboard.myTerritory') | translate}}
                  <div class="selection-display" *ngIf="vm.isTMDropdownOn">
                    <ng-container
                      *ngIf="vm.isTMDropdownOn && territorySelectionResult.selectedTerritories.length !== 1"
                    >
                      ({{ tmSelectionCount }})
                    </ng-container>
                    <ion-icon
                      (click)="presentTerritorySelectionPopover($event, vm.dsmInfo)"
                      id="dashboard-caret-dropdown"
                      name="caret-down-outline"
                      class="caret-dropdown"
                    ></ion-icon>
                  </div>
                </div>
                <div
                  class="territory-tiles"
                  #territoryTiles
                  data-cy="territory-tiles"
                >
                  <ng-container *ngIf="!vm.isLoading; else loadingTiles">
                    <app-territory-tile
                      *ngFor="let territoryTile of vm.territoryTiles"
                      class="tile"
                      [attr.data-cy]="'territory-tile-' + territoryTile.id"
                      [tile]="territoryTile"
                      (actionEmitter)="triggerTileAction($event)"
                    ></app-territory-tile>
                  </ng-container>
                  <ng-template #loadingTiles>
                    <ion-skeleton-text
                      *ngFor="let i of [].constructor(7)"
                      class="item"
                      animated
                    ></ion-skeleton-text>
                  </ng-template>
                </div>
                <div class="territory-action">
                  <ion-button
                    class="usf-green-link-button territory-toggle"
                    data-cy="territory-action-button"
                    (click)="toggleTerritoryExpansion()"
                  >
                    <span>
                      {{ isTerritoryTilesExpanded ? ('i18n.common.viewLess' |
                      translate) : ('i18n.common.viewMore' | translate) }}
                    </span>
                    <ion-icon
                      [name]="isTerritoryTilesExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                    ></ion-icon>
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <div
                  class="dashboard-data-actions"
                  [class.is-touch]="!isDesktop"
                  data-cy="dashboard-data-actions"
                >
                  <ion-segment
                    data-cy="ar-aging-toggle"
                    mode="ios"
                    [(ngModel)]="currentSection"
                    [value]="currentSection"
                    (ionChange)="listToggleChange()"
                    [disabled]="isVirtualScrollReloading"
                  >
                    <ion-segment-button
                      data-cy="account-activity-toggle"
                      [value]="DashboardSection.accountActivity"
                    >
                      <ion-label data-cy="account-activity-toggle-text">
                        {{ 'i18n.payments.paymentDashboard.accountActivity' |
                        translate }}
                      </ion-label>
                    </ion-segment-button>
                    <ion-segment-button
                      data-cy="ar-aging-toggle"
                      [value]="DashboardSection.arAging"
                    >
                      <ion-label data-cy="new-ar-aging-text">
                        {{ 'i18n.payments.paymentDashboard.ARAging' | translate
                        }}
                      </ion-label>
                    </ion-segment-button>
                  </ion-segment>

                  <div class="data-info">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span
                      >{{ 'i18n.payments.paymentDashboard.dataBasedGracePeriod'
                      | translate }}</span
                    >
                  </div>

                  <app-dashboard-search-desktop
                    *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
                    class="search-data"
                    [customerMetrics]="allCustomersMetrics"
                    (setFiltersEmitter)="setFilters($event)"
                    (inputBlurEmitter)="handleSearchBlur($event)"
                  ></app-dashboard-search-desktop>
                  <ion-button
                    *ngIf="platformService?.platformType !== platformService?.platformEnum.desktop"
                    class="usf-outline-green-button search-data"
                    data-cy="dashboard-filter-mobile-button"
                    (click)="handleSearchClick($event)"
                  >
                    <ion-icon slot="start" name="search"></ion-icon>
                    {{ 'i18n.header.search' | translate }}
                  </ion-button>

                  <ion-button
                    class="usf-outline-green-button filter-data"
                    data-cy="dashboard-filter-button"
                    (click)="openModal(null, vm.isTMDropdownOn)"
                  >
                    {{ 'i18n.common.filter' | translate }}
                    <ion-icon slot="end" name="filter"></ion-icon>
                  </ion-button>
                  <ion-button
                    class="usf-green-link-button clear-filter"
                    data-cy="dashboard-clear-all-button"
                    (click)="resetFilters()"
                    >{{ 'i18n.common.clearAll' | translate }}</ion-button
                  >
                </div>
                <div class="dashboard-data" data-cy="dashboard-data">
                  <ng-container *ngIf="!vm.isLoading; else loadingData">
                    <ion-row>
                      <ion-col size="12">
                        <ng-container
                          *ngIf="vm.customerMetrics.length > 0; else noMetrics"
                        >
                          <ng-container *ngIf="isVirtualScrollReloading">
                            <ng-container
                              *ngTemplateOutlet="loadingData"
                            ></ng-container>
                          </ng-container>
                          <app-account-activity-table
                            *ngIf="currentSection === DashboardSection.accountActivity"
                            [isDesktop]="isDesktop"
                            [customersMetrics]="customerMetrics"
                            [isDsmDashboardOn]="vm.isDsmDashboardOn"
                            [sort]="vm.sort"
                            (handleSortEmitter)="setSort($event)"
                          ></app-account-activity-table>
                          <app-ar-aging-table
                            *ngIf="currentSection === DashboardSection.arAging"
                            [isDesktop]="isDesktop"
                            [customersMetrics]="customerMetrics"
                            [sort]="vm.sort"
                            (handleSortEmitter)="setSort($event)"
                          ></app-ar-aging-table>
                        </ng-container>
                        <ng-template #noMetrics>
                          <h6
                            class="no-account-activity"
                            data-cy="no-account-activity"
                          >
                            <ng-container *ngIf="searchText; else noSearch">
                              {{
                              'i18n.payments.paymentDashboard.noMatchesSearch' |
                              translate: { searchText } }}
                            </ng-container>
                            <ng-template #noSearch>
                              {{ 'i18n.payments.paymentDashboard.noMatches' |
                              translate }}
                            </ng-template>
                          </h6>
                        </ng-template>
                      </ion-col>
                    </ion-row>
                  </ng-container>
                  <ng-template #loadingData>
                    <ion-skeleton-text
                      *ngFor="let i of [].constructor(8)"
                      class="item"
                      animated
                    >
                    </ion-skeleton-text>
                  </ng-template>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ng-container>
      <ng-template #DataLimitMessage>
        <div class="data-limit-container">
          <app-empty-states
            [title]="'i18n.payments.paymentDashboard.dataLimit.title' | translate"
            [subtitles]="['i18n.payments.paymentDashboard.dataLimit.message' | translate]"
          >
          </app-empty-states>
        </div>
      </ng-template>
      <app-footer></app-footer>
    </div>
  </cdk-virtual-scroll-viewport>

  <div
    data-cy="seller-dashboard-actions"
    class="seller-dashboard-buttons"
    [class.is-touch]="!isDesktop"
  >
    <app-top-button
      [mainScroll]="mainScroll"
      [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
    ></app-top-button>
    <div class="help-button">
      <img
        data-cy="help-button"
        src="assets/icon/custom-help-tooltip.svg"
        (click)="openHelpModal()"
        alt="help image"
      />
    </div>
  </div>

  <ion-modal
    class="modal-loading-spinner"
    data-cy="dashboard-loading-modal"
    [isOpen]="isLoading"
  >
    <ng-template>
      <app-loading-spinner
        class="ion-page"
        [loadingSpinnerModalMessage]="loadingTexts[loadingKeys[currentLoadingIndex]]"
      ></app-loading-spinner>
    </ng-template>
  </ion-modal>

  <ion-modal
    [breakpoints]="[0, 1]"
    class="ion-modal-touch"
    data-cy="dashboard-touch-search-modal"
    [initialBreakpoint]="1"
    [isOpen]="isSearchModalOpen$ | async"
    mode="ios"
    (ionModalDidDismiss)="searchModalClosed($event)"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="dashboardSearchRootPage"
        [rootPageParams]="dashboardSearchParams"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>
</ion-content>
